import React, { Component } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import { client } from '../../actions/';
import { Button, List, Alert, Spin, Tooltip, Collapse, Icon } from 'antd';
import { authHeader } from '../../helpers/auth-header';
import { dspxSorter } from '../../helpers/dspx-sort';
import WarrantyDocument from '../../components/warranty-document'
import { actions as newDocumentActions } from '../../actions/new-wdocument.actions';
import styles from './warranty-documents-container.module.scss'

const { Panel } = Collapse;

class WarrantyDocumentsContainer extends Component {

	constructor(props) {
		super(props)

		this.state = {
			documents: [],		
			dataFetching: false,
		}
	}

	getDocuments = () => {

		this.setState({ dataFetching: true })

		const rurl = '/warranty/docs/' + this.props.request;
		client.get(rurl, { headers: authHeader() }).then(res => {
			res.data.sort(dspxSorter.sorterCreateDateDesc)
			this.setState({ documents: res.data, dataFetching: false })
		}).catch(err => {
			this.setState({ documents: [], dataFetching: false })
			console.log(err)
		})
	}

	handleDocumentDelete = d => {
		this.props.dispatch(newDocumentActions.deleteDocument(d))
	}

	handleDocumentClick = (d,n) => {
		this.props.dispatch(newDocumentActions.downloadDocument(d,n))
	}

	handleDocumentAdd = (e) => {
		e.stopPropagation();	
		this.props.dispatch(newDocumentActions.openNewDocumentModal(this.props.request))
	}

	componentDidMount() {
		this.getDocuments();
	}

	componentDidUpdate(pp) {
		if ( (this.props.request == this.props.updatedRequest)
					&& ((this.props.posted && !pp.posted) || (this.props.deleted && !pp.deleted))) {
			this.getDocuments()
			this.props.dispatch({
				type: 'DOCUMENTS_REFRESHED'				
			})
		}
	}

	renderAttachmentsListItem = item => {
		return (
			<List.Item key={item.id} >
				<WarrantyDocument 
					document={item}
					onDocumentDelete={this.props.canChangeWarranty ? this.handleDocumentDelete : undefined}
					onDocumentClick={this.handleDocumentClick} />
			</List.Item>
		)
	}

	render() {
		if (this.props.hideIfEmpty && !this.state.documents?.length) {
			return null;
		}

		return (
			<div style={{ ...this.props.style }}>

				{this.props.apiResponseError && <Alert message={this.props.apiResponseText} type="error" showIcon />}

				<Spin size="large" spinning={this.state.dataFetching} tip="Загрузка..." delay={100}>
					<Collapse
            bordered={false}
            className={cn(styles.root, `dspx-warranty-documents`)}
            expandIcon={({ isActive }) => (
              <Icon
                type="caret-right"
                rotate={isActive ? 90 : 0}
              />
            )}
          >
            <Panel
							key="1"
              header={
                <div className={styles.header}>
                  <span style={this.props.hideIfEmpty ? {fontWeight: 700} : {}}>Документы по гарантии ({this.state.documents?.length ?? 0})</span>
                  {this.props.canChangeWarranty && (
										<Tooltip
											title="Добавить документ"
											placement="bottom"
										>
											<Button
												shape="circle"
												icon="file-add"
												onClick={this.handleDocumentAdd}
											/>
										</Tooltip>
                  )}
                </div>
              }
            >
              <List
                className={`dspx-warranty-documents`}
                itemLayout="vertical"
                size="small"
                pagination={{
                  hideOnSinglePage: true,
                  pageSize: 5,
                  size: 'small',
                }}
                locale={{ emptyText: 'нет документов' }}
                dataSource={this.state.documents}
                renderItem={this.renderAttachmentsListItem}
              />
            </Panel>
          </Collapse>
				</Spin>
			</div>
		)
	}
}

WarrantyDocumentsContainer.defaultProps = {
  hideIfEmpty: false,
};

function mapStateToProps(state) {

	const { warrantyDocumentsStore } = state
	const { posted, deleted, updatedRequest } = state.newWDocumentStore

	return { ...warrantyDocumentsStore, posted, deleted, updatedRequest };
}

export default connect(mapStateToProps)(WarrantyDocumentsContainer);